module.exports = __webpack_public_path__ + "static/media/multi.a480fed2.png";